<template>
  <div>
    <div class="w3-container">
      <div class="headerGridCMS w3-hide-print">
        <div>
          <header>
            <h2><template v-if="$route.params.id">Edit</template><template v-else>New</template> Product</h2>
          </header>
        </div>
        <div>
          <button class='w3-button w3-right w3-small vmiddle w3-red' style="margin-left:8px;" @click="exitProduct()">Exit</button>
          <button class='w3-button w3-right w3-small vmiddle' :class="saving || saved ? 'w3-dark-teal' : 'w3-teal'" :disabled="saving || saved" @click="saveContent()"><span v-if="!saved">Save Product</span><span v-if="saved">Product Saved</span></button>
        </div>
      </div>
      <div class="productDetailGrid">
        <div>
          <div class="inputCard">
            <header class="w3-left-align">Main</header>
            <div class="content">
              <div class="cardRow w3-padding-8">
                <label>Title</label>
                <input v-model="product.title" placeholder="My Product" class="w3-input w3-border" />
              </div>
              <div class="input-row w3-padding-8">
                <label>Description</label>
                <tinymce-editor api-key="t5p4kok2r7znye5exinvmcmpazco8x8rd3hoapujd41dps8c" :init="state.tinymceInit" v-model="product.description"></tinymce-editor>
              </div>
              <div class="input-row w3-padding-8">
                <label>Warranty</label>
                <tinymce-editor api-key="t5p4kok2r7znye5exinvmcmpazco8x8rd3hoapujd41dps8c" :init="state.tinymceInit" v-model="product.warranty"></tinymce-editor>
              </div>
              <div class="input-row w3-padding-8">
                <label>Short Description</label>
                <tinymce-editor api-key="t5p4kok2r7znye5exinvmcmpazco8x8rd3hoapujd41dps8c" :init="state.tinymceInit" v-model="product.excerpt"></tinymce-editor>
              </div>
            </div>
          </div>
          <div class="inputCard">
            <header class="w3-left-align">Product Page SEO</header>
            <div class="content">
              <div class="cardRow w3-padding-8">
                <label>Meta Title</label>
                <input v-model="product.seo.title" class="w3-input w3-border" />
              </div>
              <div class="cardRow w3-padding-8">
                <label>Meta Description</label>
                <input v-model="product.seo.description" class="w3-input w3-border" />
              </div>
            </div>
          </div>
          <!-- Images -->
          <div class="inputCard">
            <header class="w3-left-align">Images</header>
            <div class="content productImagesGrid w3-padding-8">
              <div v-for="(image, index) in product.images" :key="index">
                <div class="w3-center">
                  <img :src="(image.src && image.src !== '') ? image.src : 'https://levelsevenstudio.com/frontend/img/demos/real-estate/listings/listing-1.jpg'" style="width:100%;" />
                </div>
                <div class="cardRow w3-blue-grey" style="border-radius:0 0 5px 5px; padding:6px 6px 6px 10px;">
                  <label>Image {{index + 1}}</label>
                  <div class="w3-right-align">
                    <label :for="'productFile' + index" class="w3-button w3-green" style="margin-top:0; font-size:10px; padding:5px 10px;"><i class="fa fa-upload"></i></label>
                    <input :id="'productFile' + index" type="file" @change="uploadProductImage($event.target.files, index)" ref="fileUpload" accept=".png,.jpg" class="inputFile" />
                    <button class="w3-button w3-blue w3-round" style="padding:5px 10px; font-size:10px;" @click="chooseProductImage('images', index, product.slug, 'products')"><i class="fa fa-folder-open"></i></button>
                    <button class="w3-button w3-red w3-round" style="padding:5px 10px; font-size:10px;" @click="removeImage(index)"><i class="fa fa-trash"></i></button>
                  </div>
                </div>
              </div>
              <!-- Add Image -->
              <div>
                <div class="w3-padding-bottom w3-round" style="border:1px solid #ccc; position:relative; height:249px; max-width:230px; margin:0 auto;" @click="addImage()">
                  <svg class="svg-circleplus" viewBox="0 0 100 100" style="height: 32px; stroke: #ccc; position:absolute; top:50%; left:50%; transform:translate(-50%,-50%);">
                    <circle cx="50" cy="50" r="45" fill="none" stroke-width="4"></circle>
                    <line x1="32.5" y1="50" x2="67.5" y2="50" stroke-width="4"></line>
                    <line x1="50" y1="32.5" x2="50" y2="67.5" stroke-width="4"></line>
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div class="inputCard" v-if="productRatings && productRatings.length > 0">
            <header class="w3-left-align">Product Reviews</header>
            <div class="content">
              <div class="productRatingRow">
                <div class="productRatingCol"><b>Name</b></div>
                <div class="productRatingCol"><b>Email</b></div>
                <div class="productRatingCol"><b>Review</b></div>
                <div class="productRatingCol w3-right-align"><b>Rating</b></div>
                <div class="productRatingCol w3-right-align"><b>Action</b></div>
              </div>
              <div class="productRatingRow" v-for="(productRatingItem, index) in productRatings" :key="index">
                <div class="productRatingCol">{{productRatingItem.name}}</div>
                <div class="productRatingCol">{{productRatingItem.email}}</div>
                <div class="productRatingCol" v-if="selectedReviewID !== productRatingItem.id" @click="selectedReviewID = productRatingItem.id">{{productRatingItem.review | truncate(30)}}</div>
                <div class="productRatingCol" v-if="selectedReviewID === productRatingItem.id" @click="selectedReviewID = 0">{{productRatingItem.review}}</div>
                <div class="productRatingCol w3-right-align">{{productRatingItem.rating}} / 5</div>
                <div class="productRatingCol w3-right-align">
                  <label class="switch">
                    <input type="checkbox" v-model="productRatingItem.status" @change="updateRating($event, productRatingItem.id)">
                    <span class="slider"></span>
                  </label>
                  <button class="w3-button w3-small w3-red" style="padding:4px 8px;" @click="deleteRating(productRatingItem.id)">Delete</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="inputCard">
          <header class="w3-left-align">Details</header>
          <div class="content">
            <div class="cardRow w3-padding-8">
              <label class="w3-label">Status</label>
              <select class="w3-select w3-border" v-model="product.status">
                <option value="active">Active</option>
                <option value="draft">Draft</option>
              </select>
            </div>
            <div class="cardRow w3-padding-8">
              <label class="w3-label">Category</label>
              <div class="customSelect noselect">
                <div class="selectedCustomSelect" :class="showCustomSelect1 ? 'active' : ''" @click="showCustomSelect1 = !showCustomSelect1"><span :class="selectedCategory.title ? 'colorDark' : ''">{{selectedCategory.title || 'Choose Category'}}</span> <span style="float:right; padding:0 6px;" @click.stop="selectedCategory = {title: null}" v-if="selectedCategory.title"><i class="fa fa-times"></i></span></div>
                <div class="customSelectContainer" v-if="showCustomSelect1">
                  <div class="customSelectPosition">
                    <div v-for="(category, index) in state.siteData.content.products.categories" :key="index" class="customSelectItem" @click="selectedCategory = category; showCustomSelect1 = !showCustomSelect1">
                      <span class="customSelectTitle">{{category.title}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="cardRow w3-padding-8">
              <label>Order</label>
              <div v-if="$route.params.id">
                <input v-model.number="product.order" type="number" min="1" :max="state.siteData.content.products.items.length" class="w3-input w3-border w3-block w3-right-align" />
              </div>
              <div v-else>
                <input v-model.number="product.order" type="number" min="1" :max="state.siteData.content.products.items.length + 1" class="w3-input w3-border w3-block w3-right-align" />
              </div>
            </div>
            <div class="cardRow w3-padding-8">
              <label>Brand</label>
              <div>
                <input v-model="product.brand" class="w3-input w3-border w3-block w3-right-align" />
              </div>
            </div>
            <div class="cardRow w3-padding-8">
              <label>MPN</label>
              <div>
                <input v-model="product.mpn" class="w3-input w3-border w3-block w3-right-align" />
              </div>
            </div>
            <div class="cardRow w3-padding-8">
              <label>Price</label>
              <div>
                <input v-model="product.price" class="w3-input w3-border w3-block w3-right-align" />
              </div>
            </div>
            <div class="cardRow w3-padding-8">
              <label>Quantity</label>
              <div>
                <input v-model="product.quantity" class="w3-input w3-border w3-block w3-right-align" />
              </div>
            </div>
            <div class="cardRow w3-padding-8">
              <label>Featured</label>
              <div class="w3-right-align">
                <label class="switch">
                  <input type="checkbox" v-model="product.featured">
                  <span class="slider"></span>
                </label>
              </div>
            </div>
            <div class="cardRow w3-padding-8">
              <label>Hide Price</label>
              <div class="w3-right-align">
                <label class="switch">
                  <input type="checkbox" v-model="product.hidePrice">
                  <span class="slider"></span>
                </label>
              </div>
            </div>
            <div class="cardRow w3-padding-8" :style="product.shippable ? 'border-bottom:none;':''">
              <label>Shippable</label>
              <div class="w3-right-align">
                <label class="switch">
                  <input type="checkbox" v-model="product.shippable">
                  <span class="slider"></span>
                </label>
              </div>
            </div>
            <template v-if="product.shippable">
              <div class="cardRow w3-padding-8" style="border-bottom:none;">
                <label>Height (in)</label>
                <div>
                  <input v-model="product.package_dimensions.height" class="w3-input w3-border w3-block w3-right-align" />
                </div>
              </div>
              <div class="cardRow w3-padding-8" style="border-bottom:none;">
                <label>Width (in)</label>
                <div>
                  <input v-model="product.package_dimensions.width" class="w3-input w3-border w3-block w3-right-align" />
                </div>
              </div>
              <div class="cardRow w3-padding-8" style="border-bottom:none;">
                <label>Length (in)</label>
                <div>
                  <input v-model="product.package_dimensions.length" class="w3-input w3-border w3-block w3-right-align" />
                </div>
              </div>
              <div class="cardRow w3-padding-8">
                <label>Weight</label>
                <div style="display:grid; grid-template-columns: 3fr 1fr; grid-gap:8px;">
                  <input v-model="product.package_dimensions.weight" class="w3-input w3-border w3-block w3-right-align" />
                  <select v-model="weightType" class="w3-select w3-border w3-block w3-round"> <!-- @change="checkWeightConvert()" -->
                    <option value="oz">oz</option>
                    <option value="lbs">lbs</option>
                  </select>
                </div>
              </div>
            </template>
          </div>
        </div>
          <!-- <div class="inputCard">
            <header class="w3-left-align">Image</header>
            <div class="content">
              <div class="cardRow w3-padding-8">
                <label>Image Alt Tag</label>
                <input v-model="imageUpload.alt" placeholder="Image Description" class="w3-input w3-border" />
              </div>
              <div class="cardRow w3-padding-8">
                <label>Image</label>
                <div class="w3-right-align">
                  <label for="productFile" class="w3-button w3-green w3-small" style="margin-top:0;">Upload Image</label>
                  <input id="productFile" type="file" @change="uploadProductImage($event.target.files)" ref="fileUpload" accept=".png,.jpg" class="inputFile" />
                </div>
              </div>
              <div class="w3-center w3-border-bottom w3-padding-bottom">
                <img v-if="product.images.length > 0" :src="product.images[0]" style="width:100%; max-width:300px;" />
              </div>
            </div>
          </div> -->
          <div class="inputCard" style="padding-bottom:4px;">
            <header class="w3-left-align">Documents</header>
            <div class="content docCard" v-for="(doc, index) in product.docs" :key="index">
              <div class="docCardImg w3-center">
                <i class="fa fa-file-pdf" style="font-size: 44px;"></i><br/>
                <span>PDF</span>
              </div>
              <div class="docCardContent">
                <div class="docTitleGrid">
                  <label>Title</label>
                  <input v-model="product.docs[index].alt" class="w3-input w3-border" />
                </div>
                <div class="w3-right-align w3-block">
                  <label :for="'productDoc' + index" class="w3-button w3-green w3-small" style="margin-top:0;">Upload File</label>
                  <input :id="'productDoc' + index" type="file" @change="uploadProductDoc($event.target.files, index)" :ref="'fileUpload' + index" accept=".pdf" class="inputFile" />
                  <button class="w3-button w3-blue w3-small" @click="chooseDoc('docs', index, product.slug, 'products')">Choose File</button>
                  <button class="w3-button w3-red w3-small" @click="removeDoc(index)"><i class="fa fa-trash"></i></button>
                </div>
              </div>
            </div>
            <div class="content docCard">
              <div class="docCardImg w3-center">
                <i class="fa fa-file" style="font-size: 44px;"></i><br/>
                <span>No File</span>
              </div>
              <div class="docCardContent">
                <div class="docTitleGrid">
                  <label>Title</label>
                  <input v-model="newDoc.alt" class="w3-input w3-border" />
                </div>
                <div class="w3-right-align w3-block">
                  <label :for="'productDoc' + (product.docs.length+1)" class="w3-button w3-green w3-small" style="margin-top:0;">Upload File</label>
                  <input :id="'productDoc' + (product.docs.length+1)" type="file" @change="uploadProductDoc($event.target.files, product.docs.length+1)" :ref="'fileUpload' + product.docs.length+1" accept=".pdf" class="inputFile" />
                  <button class="w3-button w3-blue w3-small" @click="chooseDoc('docs', index, product.slug, 'products')">Choose File</button>
                  <button v-if="newDoc.src !== ''" class="w3-button w3-red w3-small" @click="removeDoc(product.docs.length+1)"><i class="fa fa-trash"></i></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'
var slug = require('slug')
var dataStore = require('../../dataStore').default

export default {
  name: 'cmsproductsdetail',
  data() {
    return {
      state: dataStore.state,
      product: {
        docs: []
      },
      imageUpload: {
        src: '',
        alt: ''
      },
      newDoc: {
        src: '',
        alt: ''
      },
      saving: false,
      saved: false,
      showCustomSelect1: false,
      selectedCategory: {},
      weightType: 'oz',
      productRatings: [],
      selectedReviewID: 0
    }
  },
  components: {
    'tinymce-editor': Editor
  },
  created() {
    if (this.$route.params.id) {
      for (let savedProduct of this.state.siteData.content.products.items) {
        if (Number(this.$route.params.id) === savedProduct.id) {
          this.product = savedProduct
          this.imageUpload.alt = savedProduct.imageAlt
          for (let savedCategory of this.state.siteData.content.products.categories) {
            if (savedCategory.id == savedProduct.category) {
              this.selectedCategory = savedCategory
              break
            }
          }
          if (this.state.productRatings && this.state.productRatings.length > 0) {
            this.productRatings = []
            for (let savedRating of this.state.productRatings) {
              if (savedProduct.id === Number(savedRating.productid)) {
                this.productRatings.push(savedRating)
              }
            }
          }
          if (!this.product.docs) {
            this.$set(this.product, 'docs', [])
          }
          if (!this.product.seo) {
            this.$set(this.product, 'seo', {title: '', description: ''})
          }
        }
      }
    } else {
      this.initProduct()
    }
  },
  computed: {
    charcount() {
      if (this.product && this.product.excerpt) {
        return this.product.excerpt.length
      } else {
        return 0
      }
    }
  },
  methods: {
    initProduct() {
      this.product = {
        id: 0,
        order: 1,
        title: '',
        description: '',
        excerpt: '',
        quantity: '',
        price: '',
        category: 0,
        brand: '',
        images: [],
        docs: [],
        imageAlt: '',
        shippable: true,
        package_dimensions: {
          height: 4,
          length: 20,
          weight: 12,
          width: 14
        },
        seo: {
          title: '',
          description: ''
        },
        featured: false,
        status: 'active',
        hidePrice: false,
        slug: ''
      }
      if (this.state.siteData.content.products.items.length > 0) {
        this.product.id = Math.max.apply(Math, this.state.siteData.content.products.items.map((product) => { return product.id })) + 1
        this.product.order = Math.max.apply(Math, this.state.siteData.content.products.items.map((product) => { return product.order })) + 1
      }
    },
    chooseProductImage(property, index, slug, type) {
      this.state.filePickerPath = property
      this.state.filePickerIndex = index
      this.state.filePickerSlug = slug
      this.state.filePickerType = type
      dataStore.getFiles()
    },
    addImage() {
      this.product.images.push({alt:'',src:''})
    },
    removeImage(index) {
      this.product.images.splice(index, 1)
    },
    uploadProductImage(files, which) {
      dataStore.uploadImage(files).then((path) => {
        this.product.images[which].src = path
      })
    },
    uploadProductDoc(files, which) {
      dataStore.uploadDoc(files).then((path) => {
        let tempDoc = {
          src: path,
          alt: this.newDoc.alt
        }
        this.product.docs.push(tempDoc)
        this.newDoc.alt = ''
      })
    },
    chooseDoc(property, index, slug, type) {
      this.state.filePickerPath = property
      this.state.filePickerIndex = index
      this.state.filePickerSlug = slug
      this.state.filePickerType = type
      dataStore.getFiles()
    },
    removeDoc(index) {
      let docs = this.product.docs
      docs.splice(index, 1)
      this.product.docs = docs
    },
    saveContent() {
      this.checkOverwrite().then((index) => {
        if (index > -2) {
          this.product.category = this.selectedCategory.id
          this.product.slug = slug(this.product.title)
          this.product.imageAlt = this.imageUpload.alt
          this.product.package_dimensions.weight = this.weightType === 'oz' ? this.product.package_dimensions.weight : this.product.package_dimensions.weight * 16
          this.weightType = 'oz'
          if (index > -1) {
            this.state.siteData.content.products.items[index] = this.product
          } else {
            this.state.siteData.content.products.items.push(this.product)
          }
          this.saving = true
          dataStore.saveSiteProducts().then((res) => {
            this.saving = false
            if (res === 'success') {
              this.$router.replace('/cms/products')
            }
          })
        }
      })
    },
    checkOverwrite() {
      return new Promise(resolve => {
        let loopIndex = 0
        for (let product of this.state.siteData.content.products.items) {
          if (product.slug === this.product.slug) {
            if (!confirm('Product with this Name already exists, overwrite?')) {
              resolve(-2)
            } else {
              resolve(loopIndex)
            }
          }
          loopIndex++
        }
        resolve(-1)
      })
    },
    deleteRating(id) {
      dataStore.deleteRating(id).then((res) => {
        if (res === 'success') {
          var filteredRatings = this.productRatings.filter((e) => {return e.id !== id})
          this.productRatings = filteredRatings
        }
      })
    },
    updateRating(event, id) {
      let status = event.target.checked
      dataStore.updateRating(id, status)
    },
    // checkWeightConvert() {
    //   if (this.weightType === 'lbs') {
    //     if (this.product.package_dimensions.weight) {
    //       this.product.package_dimensions.weight = this.product.package_dimensions.weight / 16
    //     }
    //   } else {
    //     if (this.product.package_dimensions.weight) {
    //       this.product.package_dimensions.weight = this.product.package_dimensions.weight * 16
    //     }
    //   }
    // },
    exitProduct() {
      this.initProduct()
      this.$router.go(-1)
    },
    mergeRecursive(obj1, obj2) {
      for (var p in obj2) {
        try {
          if (obj2[p].constructor === Object) {
            obj1[p] = this.mergeRecursive(obj1[p], obj2[p])
          } else {
            obj1[p] = obj2[p]
          }
        } catch (e) {
          obj1[p] = obj2[p]
        }
      }
      return obj1
    }
  }
}
</script>

<style scoped>
  .selectedCustomSelect {padding:4px 2px 4px 7px; border-color: #ccc;}
  .cardRow .w3-select {padding: 4px 5px; font-size:13px;}
  .productsTitle {font-size:1rem;}
  .productsMeta {font-size:1rem; font-family: 'Roboto', sans-serif; text-align: center;}
  .productsGrid {display:grid; grid-template-columns: 225px 1fr; grid-gap: 8px; border-bottom: 1px solid #ccc;}
  .productsGrid:last-child {border-bottom:0;}
  .productsContentGrid {display:grid; grid-template-columns: 1fr 250px 130px; grid-gap: 8px;}
  .buttons {text-align: right;}
  header.w3-left-align {padding-left:12px;}
  
  .productRatingRow {display:grid; grid-template-columns: 180px 220px 1fr 100px 120px; grid-gap: 8px; border-bottom: 1px solid #ccc; padding:6px 8px;}
  .productRatingCol {align-self: center;}

  .productDetailGrid {display:grid; grid-template-columns: 3fr 1fr; grid-gap: 8px;}
  /* .productImagesGrid {display:grid; grid-template-columns: repeat(3, 1fr); grid-gap: 8px;} */
  .productImagesGrid {display:grid; grid-template-columns: repeat(auto-fit, minmax(230px, 229px)); grid-gap:8px;}

  .docCard {display:grid; grid-template-columns: 1fr 3fr; grid-gap:8px; background:rgba(0,0,0,0.1); margin:8px; border-radius:5px;}
  .docCardImg {padding:8px 0 2px;}
  .docTitleGrid {display:grid; grid-template-columns: 40px 1fr; margin-bottom:8px;}
  .docCardContent {padding:8px;}
  .docCardContent .w3-button {padding:6px 10px;}
@media screen and (max-width:993px) {
  .productsTitle {font-size:10pt;}
  .productsMeta {font-size:10pt; font-family: 'Roboto', sans-serif;}
  .productsGrid {grid-template-columns: 125px 1fr;}
  .productDetailGrid {grid-template-columns: 1fr;}
}
</style>



// WEBPACK FOOTER //
// src/components/cms/cmsProductsDetail.vue